export default __webpack_public_path__ + "static/media/logo2.0acab601.png";